import { UseQueryResult, skipToken, useQuery } from '@tanstack/react-query';

import { callApi } from 'services/apiWrapper';
import { InstitutionWithSubscription } from 'types/InstitutionTypes';

export type InstitutionsWithSubsResponse = {
  schools: InstitutionWithSubscription[];
  districts: InstitutionWithSubscription[];
};

export const featureSwitchQueryKeys = {
  institutionSubs: () => ['institutionSubs'],
};

const fetchInstitutionsWithSubscriptions = async () => {
  const res = await callApi('/api/db/institution/subscriptions', 'GET');
  return res;
};

export const useInstituionsWithSubs = (
  hasSession: boolean,
): UseQueryResult<InstitutionsWithSubsResponse, Error> => {
  return useQuery({
    queryKey: featureSwitchQueryKeys.institutionSubs(),
    queryFn: hasSession
      ? () => fetchInstitutionsWithSubscriptions()
      : skipToken,
    staleTime: 60 * 5 * 1000,
  });
};
